import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {SHA256} from 'crypto-js';
import * as CryptoJS from 'crypto-js';
import {Constants} from '../components/common/constants';
import {Observable, Subject} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Router} from '@angular/router';
import {PaymentData} from '../models/application/payment-data.model';
import {Step} from '../models/application/step.model';
import {UserData} from '../models/application/client-data.model';
import { EncryptServiceService } from './encrypt-service/encrypt-service.service';


@Injectable({
    providedIn: 'root'
})
export class SessionService {
    serverUrl :string;
    geoPositionURL:string;
    geoLocalication:string;
    authDataKey = btoa('AUTH_DATA_APPLICATION');
    authDayValidation = btoa('AUTH_EXP_VER');
    newDataAccount = btoa('NEW_DATA_ACCOUNT');
    countryDataApp = btoa('COUNTRY_DATA_APP');
    initSesionText = btoa('INIT_SESSION_TEXT');
    paymentData = btoa('PAYMENT_DATA');
    paymentSteps = btoa('PAYMENT_STEPS');
    paymentAccountData = btoa('PAYMENT_ACCOUNT_DATA');
    paymentMethodData = btoa('PAYMENT_METHOD_DATA');
    paymentBillingData = btoa('PAYMENT_BILLING_DATA');
    cartItemsData = btoa('CART_ITEMS_DATA');
    downloadCumplimientoPais = btoa('DOWN_PAIS_CUMPLIMIENTO');
    sessionLogin = btoa('AUTH_SESSION_LOGIN');
    AUTHORIZATION_HEADER_NAME = 'Authorization';
    private payData: any;
    private promoCode: any;
    private emitterSessionText: Subject<any> = new Subject<any>();
    public sessionTextListener$ = this.emitterSessionText.asObservable();
    private emitterUpdateSteps: Subject<any> = new Subject<any>();
    public updateStepsListener$ = this.emitterUpdateSteps.asObservable();
    private emitterCartItems: Subject<any> = new Subject<any>();
    public listenCartItems$ = this.emitterCartItems.asObservable();
    public stepsNames = {
        accountStep: 'account',
        methodStep: 'method',
        billingStep: 'billing'
    };

    constructor(
        private http: HttpClient,
        private router: Router,
        private _encryptService:EncryptServiceService,
        ) {
            this.serverUrl = this._encryptService.decryptData(environment.BASE_URL);
            this.geoPositionURL = this._encryptService.decryptData(environment.SERVER_URL_POSITION);
            this.geoLocalication = this._encryptService.decryptData(environment.SERVER_URL_LOCALIZATION);
        }

    emitCartItems(): void {
        this.emitterCartItems.next();
    }

    emitNewSessionText(value): void {
        this.setInitText(value);
        this.emitterSessionText.next(value);
    }

    emitUpdateSteps(): void {
        this.emitterUpdateSteps.next();
    }

    getEncryptedData(data: string, key): string {
        const cipherTextData = CryptoJS.AES.encrypt(JSON.stringify(data), key);
        return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(cipherTextData));
    }

    login(user: string, password: string, isSha?): Observable<any> {
        const body = {
            grant_type: 'password',
            username: `${user}`,
            password: `${isSha ? password : SHA256(password)}`
        };
        return this.http.post<any>(`${this.serverUrl}${Constants.endpoints.login}`, this.saveRequest(body));
    }

    saveRequest(body): string {
        const key = CryptoJS.enc.Utf8.parse(Constants.LOGIN_KEY);
        const iv = CryptoJS.enc.Utf8.parse(Constants.LOGIN_IV);
        return CryptoJS.AES.encrypt(JSON.stringify(body), key, {iv},
            {keySize: 16, mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7}).toString();
    }

    // CORREO YA UTILIZADO
    validEmail(email: string): Observable<any> {
        const config = {headers: new HttpHeaders()};
        config.headers = config.headers.set('Content-Type', 'application/json');
        config.headers = config.headers.set('applicationSrc', 'fad');
        return this.http.post<any>(`${this.serverUrl}${Constants.endpoints.validEmail}`, email, config);
    }

    // INFO USUARIO
    infoUsuario(): Observable<any> {
        const config = {headers: new HttpHeaders()};
        config.headers = config.headers.set('Content-Type', 'application/json');
        return this.http.get<any>(`${this.serverUrl}${Constants.endpoints.infoUser}`, config);
    }

    // CREAR CUENTA DE USUARIO
    register(request: any): Observable<any> {
        const config = { headers: new HttpHeaders() };
        config.headers = config.headers.set('Content-Type',  'application/json');
        config.headers = config.headers.set('applicationSrc', 'fad');
        return this.http.post<any>(`${this.serverUrl}${Constants.endpoints.register}`, request, config);
    }

    // CREAR CUENTA DE USUARIO
    checkTelefono(request: any): Observable<any> {
        const config = {headers: new HttpHeaders()};
        config.headers = config.headers.set('Content-Type', 'application/json');
        return this.http.post<any>(`${this.serverUrl}${Constants.endpoints.checkMovil}`, request, config);
    }

    // RESTABLECER CONTRASENA
    resetPassword(email: string): Observable<any> {
        const config = {headers: new HttpHeaders()};
        config.headers = config.headers.set('Content-Type', 'application/json');
        return this.http.post<any>(`${this.serverUrl}${Constants.endpoints.resetPassword}`, {username: email}, config);
    }

    // GUARDAR CONTRASENA DESPUES DE RECUPERARLA
    saveResetPassword(request: any): Observable<any> {
        const config = {headers: new HttpHeaders()};
        config.headers = config.headers.set('Content-Type', 'application/json');
        return this.http.post<any>(`${this.serverUrl}${Constants.endpoints.changePassword}`, request, config);
    }

    getAuthData(): any {
        const auth = localStorage.getItem(this.authDataKey);
        if (auth) {
            return JSON.parse(atob(auth));
        }
        return null;
    }

    setAuthData(data): void {
        localStorage.setItem(this.authDataKey, btoa(JSON.stringify(data)));
    }

    setInitText(value): void {
        localStorage.setItem(this.initSesionText, value);
    }

    setLoginSession(value): void {
        localStorage.setItem(this.sessionLogin, value);
    }

    getLoginSession(): any {
        return localStorage.getItem(this.sessionLogin);
    }

    getInitText(): any {
        return localStorage.getItem(this.initSesionText);
    }

    clearData(): void {
        localStorage.clear();
        this.router.navigate(['/']);
    }

    getCartItems(): any[] {
        const items = localStorage.getItem(this.cartItemsData);
        if (items) {
            return JSON.parse(items);
        }

        return [];
    }

    clearCartItems(): void {
        localStorage.setItem(this.cartItemsData, JSON.stringify([]));
        this.emitCartItems();
    }

    updateCartList(item: PaymentData, isAdd?: boolean, num?: number, justUpdate?: boolean): void {
        let itemsInCart: PaymentData[] = this.getCartItems();
        if (justUpdate) {
            if (itemsInCart.length) {
                const itemExist = itemsInCart.find(data => data.product === item.product && data.subscription === item.subscription);
                if (itemExist) {
                    itemExist.quantity = item.quantity;
                    itemExist.transactions = item.transactions;
                    itemExist.pricing = item.pricing;
                    itemExist.complements = [...item.complements];
                    itemExist.pricingUSD = item.pricingUSD;
                }
            }
        } else {
            if (itemsInCart.length) {
                const itemExist = itemsInCart.find(data => data.product === item.product && data.subscription === item.subscription);
                if (isAdd) {
                    if (itemExist) {
                        if (num) {
                            itemExist.quantity = num;
                        }
                    } else {
                        itemsInCart.push(item);
                    }
                } else {
                    if (itemExist) {
                        itemsInCart = itemsInCart.filter(data => {
                            if (data.product !== item.product || data.subscription !== item.subscription) {
                                return data;
                            }
                        });
                    }
                }
            } else {
                itemsInCart.push(item);
            }
        }
        localStorage.setItem(this.cartItemsData, JSON.stringify(itemsInCart));
        this.emitCartItems();
    }

    setPaymentData(data: PaymentData): void {
        localStorage.setItem(this.paymentData, JSON.stringify(data));
    }

    getPaymentData(): any {
        const data = localStorage.getItem(this.paymentData);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    }

    setPaymentAccount(data): void {
        localStorage.setItem(this.paymentAccountData, btoa(JSON.stringify(data)));
    }

    getPaymentAccount(): any {
        const data = localStorage.getItem(this.paymentAccountData);
        if (data) {
            return JSON.parse(atob(data));
        }
        return null;
    }

    setPaymentBilling(data): void {
        localStorage.setItem(this.paymentBillingData, JSON.stringify(data));
        this.emitUpdateSteps();
    }

    getPaymentBilling(): any {
        const data = localStorage.getItem(this.paymentBillingData);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    }

    setPaymentMethod(data): void {
        localStorage.setItem(this.paymentMethodData, JSON.stringify(data));
        this.emitUpdateSteps();
    }

    getPaymentMethod(): any {
        const data = localStorage.getItem(this.paymentMethodData);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    }

    getPaymentSteps(): any {
        const data = localStorage.getItem(this.paymentSteps);
        if (data) {
            return JSON.parse(data);
        }
        return null;
    }

    genPaymentSteps(): any {
        if (!localStorage.getItem(this.paymentSteps)) {
            const steps = {
                accountStep: new Step(this.stepsNames.accountStep),
                methodStep: new Step(this.stepsNames.methodStep),
                billingStep: new Step(this.stepsNames.billingStep)
            };
            localStorage.setItem(this.paymentSteps, JSON.stringify(steps));
            this.updateSteps();
        }
    }

    updateSteps(stepName?: string): any {
        const steps = this.getPaymentSteps();
        if (steps) {
            if (stepName) {
                steps[stepName].completed = true;
                steps[stepName].next = false;
            }
            Object.keys(steps).forEach(key => {
                switch (steps[key].name) {
                    case this.stepsNames.accountStep:
                        steps[key].completed = this.getPaymentAccount() || this.getAuthData();
                        steps[key].isNext = !steps.accountStep.completed && !steps.methodStep.completed;
                        break;
                    case this.stepsNames.methodStep:
                        steps[key].completed = this.getDataPay();
                        steps[key].isNext = !steps.methodStep.completed && steps.accountStep.completed;
                        break;
                    case this.stepsNames.billingStep:
                        steps[key].completed = this.getPaymentBilling();
                        steps[key].isNext = steps.methodStep.completed && steps.methodStep.completed;
                        break;
                }
            });
            localStorage.setItem(this.paymentSteps, JSON.stringify(steps));
        }

        return steps;
    }

    setDataPay(payData: any): void {
        this.payData = payData;
        this.emitUpdateSteps();
    }

    getDataPay(): any {
        return this.payData;
    }

    setCookies(cookie: any): void {
        localStorage.setItem('twgx5wxc7qorev0wys1re2olkl9mdo2i', String(cookie));
    }

    getCookies(): any {
        return localStorage.getItem('twgx5wxc7qorev0wys1re2olkl9mdo2i');
    }


    setDayExpiration(): void {
        localStorage.setItem(this.authDayValidation, String(new Date().getDate() + '/' + new Date().getMonth()));
    }

    getDayExpiration(): any {
        return localStorage.getItem(this.authDayValidation);
    }

    newDataSession(): void {
        localStorage.removeItem(this.authDataKey);
        localStorage.removeItem(this.sessionLogin);
        localStorage.removeItem(this.paymentSteps);
        localStorage.removeItem(this.paymentAccountData);
        localStorage.removeItem(this.initSesionText);
        localStorage.removeItem(this.authDayValidation);
    }

    getSessionService(): any {
        if (!this.getAuthData()) {
            const userPay = Constants.decryptData(Constants.configSession.userK, Constants.configSession.userP);
            const passwordPay = Constants.decryptData(Constants.configSession.passK, Constants.configSession.passP);
            this.login(userPay, passwordPay, true).subscribe(
                res => {
                    this.setAuthData(res);
                    this.setLoginSession(null);
                }
            );
        } else {
            if (this.getDayExpiration() !== String(new Date().getDate() + '/' + new Date().getMonth())) {
                this.newDataSession();
            }
        }
    }

    setPromoCode(promoCode: any): void {
        this.promoCode = promoCode;
    }

    getPromoCode(): any {
        if (this.promoCode) {
            return this.promoCode;
        }
        return null;
    }

    getLocationUser(): any {
        // @ts-ignore
        return this.http.post<any>(this.geoPositionURL + '?key=AIzaSyBlVuPLfnZwQVy0HJl-d1qg3EvRk0exNDg');
    }

    getCountrieUser(lat: string, lng: string): any {
        // @ts-ignore
        return this.http.post<any>(this.geoLocalication + '?latlng=' + lat + ',' + lng + '&key=AIzaSyBlVuPLfnZwQVy0HJl-d1qg3EvRk0exNDg');
    }

    setCountryData(value): void {
        localStorage.setItem(this.countryDataApp, value);
    }

    getCountryData(): any {
        return localStorage.getItem(this.countryDataApp) === 'true';
    }

    setAccountData(value): void {
        localStorage.setItem(this.newDataAccount, value);
    }

    getAccountData(): any {
        return localStorage.getItem(this.newDataAccount);
    }

    setDownloadCumplimiento(value): void {
        localStorage.setItem(this.downloadCumplimientoPais, value);
    }

    getDownloadCumplimiento(): any {
        const data = localStorage.getItem(this.downloadCumplimientoPais);
        if (data) {
            return data;
        }
        return null;
    }

}
